export const blockIconsUiactionsCloseNew = (
	<span className='material-symbols-outlined'>close</span>
);
